import type { ManifestRouteDefinition } from '@/core/manifest/types'

export function joinRoutePath(parent: string, segment: string): string {
  const p = parent.replace(/\/$/, '')
  const s = segment.replace(/^\//, '')
  if (!p) return `/${s}`
  return `${p}/${s}`
}

/** Full URL path for each route `key` (for sidebar / tooling) */
export function collectManifestPathByKey(
  roots: ManifestRouteDefinition[]
): Record<string, string> {
  const out: Record<string, string> = {}

  function walk(def: ManifestRouteDefinition, parentFull: string) {
    let full: string
    if (def.isIndex) {
      full = parentFull
    } else {
      const segment = def.path ?? ''
      if (!segment) {
        full = parentFull
      } else if (segment.startsWith('/')) {
        full = segment
      } else {
        full = joinRoutePath(parentFull, segment)
      }
    }

    if (def.children?.length) {
      out[def.key] = full
      for (const c of def.children) {
        walk(c, full)
      }
    } else {
      out[def.key] = full
    }
  }

  for (const r of roots) {
    walk(r, '')
  }
  return out
}
